var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 3a.75.75 0 0 1 .633.347l10.5 16.5A.75.75 0 0 1 19.5 21H15a.75.75 0 0 1-.633-.347l-10.5-16.5A.75.75 0 0 1 4.5 3zm6.412 16.5h2.722l-9.546-15H5.866z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.121 12.952a.75.75 0 0 1 1.11 1.008l-6.176 6.794a.75.75 0 0 1-1.11-1.009zM18.945 3.246a.75.75 0 0 1 1.11 1.008l-6.176 6.795a.75.75 0 0 1-1.11-1.01z"
  })));
};
export default SvgX;